import { map } from 'lodash';
import { createSelector } from 'reselect';

export const getWriters = state => state.writers;

export const getWritersForSelect = createSelector(
  [getWriters],
  writers => map(writers, writer => ({ value: writer._id, label: writer.name })),
);
